import { render, staticRenderFns } from "./SetSand.vue?vue&type=template&id=1c63a53c&scoped=true&"
import script from "./SetSand.vue?vue&type=script&lang=js&"
export * from "./SetSand.vue?vue&type=script&lang=js&"
import style0 from "./SetSand.vue?vue&type=style&index=0&id=1c63a53c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63a53c",
  null
  
)

export default component.exports